import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import packageJson from "../../package.json";

export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const fetchAllRoles = createAsyncThunk(
  'Roles/fetchAllRoles',
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const res = await axios.get(`${BaseUrl}/getRoles`, {       headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`, // Add the auth token from localStorage
        'Content-Type': 'application/json'
      }, });
      const result = await res.data.data;
      return result;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        //Handle the 500 error server   error specifically
        localStorage.removeItem("isLoggedIn");
        window.location.reload()
      } 
      return rejectWithValue(error.message);
    }
  }
);



const RolesSlice = createSlice({
  name: 'Roles',
  initialState: { Roles: [], loading: false, error: null },
  reducers: {
    clearRoles: (state) => {
      state.Roles = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: {
    //fetch
    [fetchAllRoles.pending]: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    [fetchAllRoles.fulfilled]: (state, action) => {
      state.Roles = action.payload;
      state.loading = false;
    },
    [fetchAllRoles.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});
export const { clearRoles } = RolesSlice.actions;
export default RolesSlice.reducer;

